<template>
    <div class="form-black">
        <img :src="'/images/black-car-2025-v0.png'" :alt="`AutoBesikos Black Friday`" width="685" height="358">
        <h2>Black Friday Alert!</h2>
        <p>Συμπλήρωσε το email σου και λάβε άμεσα τον κωδικό σου για έκπτωση 500€ - 4.000€ σε όποιο μεταχειρισμένο αυτοκίνητο επιλέξεις!</p>
        <form class="form-model" @submit.prevent="submitForm" id="form-black-friday">
            <div class="form-text">
                <label for="email">Συμπλήρωσε  το email σου για να λάβεις το κουπόνι:</label>
                <input type="email" id="email" v-model="form.email" placeholder="Εισάγετε το email σας" required/>
                <InputError :message="errors.email" />
            </div>
            <div class="form-model-bottom">
                <div>
                    <input type="checkbox" v-model="form.checkBox" :id="`checkbox-black-friday`" required/>
                    <label :for="`checkbox-black-friday`">Αποδέχομαι την επικοινωνία με την AutoBesikos</label>
                </div>
                <InputError :message="errors.checkbox" />
                <div>
                    <Button @click="submitForm" inline submit :processing="processing">Λάβε το κουπόνι</Button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { useForm } from "@inertiajs/vue3";
    import Button from "../Button/Button.vue";
    import InputError from "./InputError.vue";

    export default {
        components: {
            Button, InputError,
        },
        props: {
            interestFor: String,
            page: String,
        },
        setup(props, { slots, attrs }) {
            const form = useForm({
                email: '',
                checkBox: false,
            });

            const errors = useForm({
                email: '',
                checkbox: '',
            });

            return { form, errors };
        },
        data() {
            return {
                processing: false,
                checkBoxMessage: 'Πρέπει να αποδεχτείς την επικοινωνία με την AutoBesikos',
            }
        },
        methods: {
            submitForm() { 
                if ( this.form.checkBox ) {
                    this.processing = true;
                    axios.post('/black-friday-coupon',
                        this.form
                    ).then((response) => {
                        // Clear values
                        this.form.reset();
                        this.errors.reset();
                        this.processing = false;
                        this.$helper.getFormMessage(true, this.$global.message, true, 'Η φόρμα στάλθηκε', 'green', response, this.$global.current_pathname);
                    }).catch((error) => {
                        const getErrors = Object.entries(error.response.data.errors);
                        this.errors.reset();
                        this.processing = false;
                        if (getErrors.length > 0) {
                            getErrors.map((e) => { this.errors[e[0]] = e[1][0]; })
                        } else {
                            this.$helper.getFormMessage(false, this.$global.message, true, 'Κάτι πήγε στραβά', 'red', error);
                        }
                    })
                } else {
                    this.errors.checkbox = this.checkBoxMessage;
                }
            },
        },
    }
</script>